import { connect } from "react-redux";
import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button, Spin } from "antd";
import PropTypes from "prop-types";
import IntroduccioIndividuFenofasesDetallImatge from "./IntroduccioIndividuFenofasesDetallImatge";
import IntroduccioIndividuFenofasesDetallOpcions from "./IntroduccioIndividuFenofasesDetallOpcions";
import IntroduccioIndividuFenofasesComentari from "./IntroduccioIndividuFenofasesComentari";
import IntroduccioIndividuFenofasesDetallComentari from "./IntroduccioIndividuFenofasesDetallComentari";
import { formatStringDate, MASCARA_DDMMYYYY } from "../../utils/dates";
import {
  getPeticioIntroduccioEnCurs,
  getIdEspecieIntroduccio
} from "../../reducers";
import * as rutes from "../../routes";
import { Link } from "react-router-dom";
import styles from "./IntroduccioIndividuFenofasesCarrusel.module.css";
import {
  MISSATGE_SPIN_OBSERVACIONS,
  TITOL_FENOFASES
} from "../../constantsFormularis";
import { setTitolApartat } from "../../actions";

export class IntroduccioIndividuFenofasesCarrusel extends Component {
  state = {
    disableComponents: false
  };
  disableComponent = value => {
    this.setState({ disableComponents: value });
  };

  componentDidMount() {
    this.props.setTitolApartat(TITOL_FENOFASES);
  }

  getObservaciofenofasesIndividu(fenofase, valors) {
    let observacioActual = {};
    Object.keys(valors).forEach(valor => {
      if (
        valors[valor].idFenofase === fenofase.idFenofase &&
        fenofase.fenofaseIdIndividu === valors[valor].idIndividu
      ) {
        observacioActual.valorActual = valors[valor].valor;
        observacioActual.idObservacion = valors[valor].id;
        observacioActual.idIndividuFenofase = valor;
        observacioActual.idComentari = valors[valor].textVisible
          ? valors[valor].idComentari
          : "";
        observacioActual.textComentari = valors[valor].textVisible
          ? valors[valor].textComentari
          : "";
        observacioActual.mostrarComentari = valors[valor].mostrarComentari;
        observacioActual.esborrarComentaris = valors[valor].esborrarComentaris;
        observacioActual.textVisible = valors[valor].textVisible;
      }
    });
    return observacioActual;
  }

  getfenofasesIndividu(fenofases, idIndividu, individus) {
    let arrayFenofases = [];
    Object.keys(fenofases).forEach(fenofase => {
      if (fenofases[fenofase].idIndividu.indexOf(idIndividu) !== -1) {
        let copy = Object.assign({}, fenofases[fenofase]);
        copy.idFenofase = Number(fenofase);
        //Inserim url imatge fenofase individu
        if (individus[idIndividu]) {
          const fotosFenofase = individus[idIndividu].fotosFenofase;
          if (fotosFenofase) {
            copy.urlFotoIndividu = fotosFenofase[fenofase]
              ? fotosFenofase[fenofase].url
              : "";
            copy.descripcioIndividu = individus[idIndividu].descripcio;
            copy.fenofaseIdIndividu = idIndividu;
            arrayFenofases.push(copy);
          }
        }
      }
    });
    return arrayFenofases;
  }

  showImatge(especie, fenofase, valors, idx, nFenofases) {
    const observacioActual = this.getObservaciofenofasesIndividu(
      fenofase,
      valors
    );

    return (
      <div key={fenofase.idFenofase} className={styles.fenofases}>
        <h3>
          {fenofase.nom}{" "}
          <span className={styles.nfases}>
            {idx + 1} de {nFenofases}
          </span>
        </h3>
        <div id={"fenofase" + fenofase.idFenofase} className={styles.layout}>
          <IntroduccioIndividuFenofasesDetallImatge
            fenofase={fenofase}
            especie={especie}
            onDisableComponent={this.disableComponent}
          />

          <IntroduccioIndividuFenofasesDetallOpcions
            fenofase={fenofase}
            observacioActual={observacioActual}
            onDisableComponent={this.disableComponent}
          />

          <IntroduccioIndividuFenofasesComentari
            observacioActual={observacioActual}
            onDisableComponent={this.disableComponent}
          />
        </div>
        <IntroduccioIndividuFenofasesDetallComentari
          observacioActual={observacioActual}
          onDisableComponent={this.disableComponent}
        />
      </div>
    );
  }

  goToCarouselIndex(idEspecie, arrayFenofasesIndividu) {
    for (let i = 0; i < arrayFenofasesIndividu.length; i++) {
      const fenofasesIndividu = arrayFenofasesIndividu[i][0];
      if (fenofasesIndividu && fenofasesIndividu.idEspecie === idEspecie) {
        return i;
      }
    }
    return 0;
  }

  getEspecie(individuFenofases, especies) {
    let objEspecie;
    const idEspecie =
      individuFenofases[0] && individuFenofases[0].idEspecie
        ? individuFenofases[0].idEspecie
        : "";
    Object.keys(especies).forEach(especie => {
      if (Number(especie) === idEspecie) {
        objEspecie = especies[especie];
      }
    });
    return objEspecie;
  }

  getDescripcioIndividu(individuFenofases) {
    return Array.isArray(individuFenofases) &&
    individuFenofases[0] &&
    individuFenofases[0].descripcioIndividu
      ? individuFenofases[0].descripcioIndividu
      : "";
  }

  listaIndividusFenofases(classes, individus, fenofases) {
    let arrayIndividusOrdenadesPerClasse = [];

    Object.keys(classes)
      .map(classe =>
        classes[classe].individus.slice().sort((a, b) => {
          return a - b;
        })
      )
      .flat()
      .forEach(idIndividu => {
        arrayIndividusOrdenadesPerClasse.push(
          this.getfenofasesIndividu(fenofases, Number(idIndividu), individus)
        );
      });

    return arrayIndividusOrdenadesPerClasse;
  }

  render() {
    const {
      classes,
      especies,
      fenofases,
      individus,
      valors,
      data,
      isPeticioEnCurs,
      idEspecie
    } = this.props;

    const listaIndividusFenofases = this.listaIndividusFenofases(
      classes,
      individus,
      fenofases
    );

    const dataMostrar = formatStringDate(data, MASCARA_DDMMYYYY);
    let i = 0;

    const settings = {
      className: "carousel",
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      initialSlide: this.goToCarouselIndex(idEspecie, listaIndividusFenofases)
    };

    return (
      <Spin
        spinning={isPeticioEnCurs}
        tip={MISSATGE_SPIN_OBSERVACIONS}
        delay={0}
      >
        <div className={styles.wrapper}>
          <Slider {...settings}>
            {listaIndividusFenofases.map(individuFenofases => {
              const especieAMostrar = this.getEspecie(
                individuFenofases,
                especies
              );

              return (
                <div
                  id={
                    "especie" +
                    (especieAMostrar && especieAMostrar.idEspecie
                      ? especieAMostrar.idEspecie
                      : null)
                  }
                  key={i++}
                  className={styles.carousel}
                >
                  <h2>
                    {especieAMostrar && especieAMostrar.nomEspecie ? (
                      especieAMostrar.nomEspecie
                    ) : null}{" "}
                    <span>({dataMostrar})</span>
                  </h2>
                  <div className={styles.descripcio}>
                    {this.getDescripcioIndividu(individuFenofases)}
                  </div>
                  {individuFenofases.map((fenofase, idx) => {
                    return this.showImatge(
                      especieAMostrar && especieAMostrar.nomEspecie
                        ? especieAMostrar.nomEspecie
                        : null,
                      fenofase,
                      valors,
                      idx,
                      individuFenofases.length
                    );
                  })}
                </div>
              );
            })}
          </Slider>
          <Link
            className={styles.back}
            to={{
              pathname: rutes.rutaObservacionsIntroduccio,
              query: { render: false }
            }}
          >
            <Button icon="left">Tornar</Button>
          </Link>
        </div>
      </Spin>
    );
  }
}

IntroduccioIndividuFenofasesCarrusel.propTypes = {
  classes: PropTypes.object.isRequired,
  especies: PropTypes.object,
  fenofases: PropTypes.object,
  individus: PropTypes.object,
  especie: PropTypes.string,
  valors: PropTypes.object,
  data: PropTypes.string,
  isPeticioEnCurs: PropTypes.bool,
  setTitolApartat: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    classes: state.classes.introduccio,
    especies: state.especies,
    fenofases: state.fenofases,
    individus: state.individus.dades.introduccio,
    valors: state.introduccio ? state.introduccio.valors : {},
    data: state.introduccio.data,
    isPeticioEnCurs: getPeticioIntroduccioEnCurs(state),
    idEspecie: getIdEspecieIntroduccio(state)
  };
};

export default connect(mapStateToProps, {
  setTitolApartat
})(IntroduccioIndividuFenofasesCarrusel);
